import React from "react";

const About = () => {
  return (
    <div className="about-me2">
      <h1>&#60; about me /&#62;</h1>
      <br/>
      <p>
        <strong>A truly enthusiastic of developing technology systems.</strong>
        <br />
        <br />
        I have always been fascinated for PC ever since I got my first one,
        thenceforth, I was all about messing with it to get to learn more and
        more.
        <br />
        Over the years I was able to get to know, understand and manipulate
        codes from various systems, mainly internet's.
        <br />
        Today I have an extensive front-end tools knowledge. Experienced with
        vanilla JavaScript and many modern frameworks and libraries like
        Reactjs, Angular, Vue and Next.
      </p>
    </div>
  );
};

export default About;
